import React from "react";
import DOMPurify from "dompurify";
import ebautPhotoTwo from "../../img/pro-nas.jpg";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function EbAutOne({ebautData}) {

    //console.log(ebautData);

    let statistic = [
        {
            number: '8',
            description: 'модулів'
        },
        {
            number: '30',
            description: 'актуальних напрямів у диджиталі'
        },
        {
            number: '30+',
            description: 'годин навчання'
        },
        {
            number: '35+',
            description: 'спікерів'
        },
        {
            number: '2500+',
            description: 'учасниць'
        }
    ]

    return (
        <>
            {
                ebautData ?
                    <section className="relative pt-20 overflow-hidden" id="ebaut">
                        <div className="container w-[90%] max-w-screen-lg lg:w-3/4 mx-auto rounded-2xl">
                            <div
                                className="md:flex relative z-20 gap-9">

                                <div className="w-full md:w-1/2 order-2 lg:order-1">
                                    {/*<ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">Про івент</h6></ScrollAnimation>*/}
                                    <ScrollAnimation animateIn="animate__fadeInUp">
                                        <h2
                                        className="sm:text-4xl text-2xl mb-4 uppercase">{ebautData.ebaut_title}</h2>
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__fadeInUp">
                                        <div
                                            className="mb-[30px] text-[16px] md:mb-[30px] rev-slide-up grid gap-2"
                                            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(ebautData.ebaut_text, {sanitize: true})}}
                                        />
                                    </ScrollAnimation>
                                </div>
                                <div className="order-1 lg:order-2">
                                    {
                                        statistic ? statistic.map((item, index) => (
                                            <ScrollAnimation animateIn="animate__fadeInUp" className="mb-4 flex items-center">
                                                <h3 className="text-4xl text-center mr-3">{item.number}</h3>
                                                <p className="text-center">{item.description}</p>
                                            </ScrollAnimation>
                                        )) : ''
                                    }
                                </div>

                            </div>

                        </div>
                    </section> : ''
            }
        </>
    )
}

export default EbAutOne